import React from "react";
import "../styles/components/NavButton.css";
import PropTypes from "prop-types";

const NavButton = (props) => {
  const redirectToPage = () => {
    // FILL IN URL WHEN DOMAIN IS PURCHASED
    const url = `http://impcreature.neocities.org/${props.redirect}`;
    window.open(url, "_self");
  };

  return (
    <button type="button" onClick={redirectToPage}>
      {props.label}
    </button>
  );
};

NavButton.propTypes = {
  label: PropTypes.string.isRequired,
  redirect: PropTypes.string.isRequired,
};

export default NavButton;
